import { render, staticRenderFns } from "./MedicalStaffAdd.vue?vue&type=template&id=670824c1"
import script from "./MedicalStaffAdd.vue?vue&type=script&lang=js"
export * from "./MedicalStaffAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports